import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

const PdfSplitterDropZone = ({ onFile }) => {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleFileInputChange = (event) => {
    const file = (event.target.files || [])[0];
    if (file) onFile(file);
    event.target.value = '';
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragOver(false);
    const file = (event.dataTransfer.files || [])[0];
    if (file) onFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragOver(false);
  };

  return (
    <div
      className={`pdf-splitter-dropzone ${isDragOver ? 'pdf-splitter-dropzone-active' : ''}`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragOver}
      onDragLeave={handleDragLeave}
      onClick={() => fileInputRef.current && fileInputRef.current.click()}
    >
      <FontAwesomeIcon icon={faUpload} className="pdf-splitter-dropzone-icon" />
      <p className="pdf-splitter-dropzone-title">Drag a PDF here to split it</p>
      <p className="pdf-splitter-dropzone-subtitle">
        or click to choose a file. There is no size limit on the file you drop here &mdash;
        only on the individual slices you create.
      </p>
      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,application/pdf"
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};

export default PdfSplitterDropZone;
